import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"
import {postQueries} from "../queries/postQueries"
import {patchQueries} from "../queries/patchQueries"


var data=JSON.parse(sessionStorage.getItem("authAshia"))?.profile



export async function getProfileEvenement(){
    var datas=[]
    await getQueries("profiles/"+data.id).then(data=>{
       datas=data;
    })
    
    return await datas
}

export async function getEvenementByUser(data){
    var datas=[]
    await postQueries("evenement/getEvenementByUser",data).then(res=>{
        datas=res
       
    })
   return await datas
}


export async function getEvenementByProfile(data){
    var datas=[]
    await postQueries("evenement/getEvenementByProfile",data).then(async (res)=>{
        datas=res

        if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==data?.profile_id ){
            await getQueries("profiles/"+localStorage.getItem("private_id")).then(data2=>{
                let data_ress=res.concat(data2?.evenements)
                datas=_.uniqBy(data_ress,"id")
                
            })
          }
       
    })
   return await datas
}

export async function getEvenementBySearch(data){
    var datas=[]
    await postQueries("evenement/searchEvenement",data).then(res=>{
        datas=res
       
    })
   return await datas
}


// export  getLangue

export async function removeElement(data,url){
    var datas={}
    await postQueries(url,data).then(res=>{
        //datas=res
    })
   // return await datas
}

export async function removeElements(data,url){
    var datas={}
    for(var i=0;i<data.length;i++){
    await postQueries(url,data[i]).then(res=>{
       
    })
   }
    
}

export async function updateEvenement(data){
    var datas={}
    const id=sessionStorage.getItem("idEvenement")
    await patchQueries("evenements/"+id,data).then(res=>{
        datas=res
    })
    return await datas
}



  
        